import {withIMask} from './components/withIMask';
import {SpartanTextField} from './SpartanTextField';

export const SpartanPhoneField = withIMask(SpartanTextField, {
  mask: [{mask: '(000) 000 0000'}],
});
